import useSWR, { SWRConfiguration } from 'swr';

import { Event } from '../../types/event';
import { GetAllAsync, GetAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { GameDocument } from '../../types/game-document';

const EventsEndpoint = `events`;

export const useGetEvents = (params?: string, options?: SWRConfiguration) => {
  const { data, error, isLoading, mutate } = useSWR<KendoGridResult<Event>>(
    `${EventsEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetExpandedEventsAsAdmin = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<KendoGridResult<Event>>(
    `admin/${EventsEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetGameDocumentContentByPlaylistId = (
  eventId?: string,
  playlistId?: number,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<GameDocument>(
    eventId && playlistId
      ? `${EventsEndpoint}/${eventId}/playlists/${playlistId}/document/content`
      : null,
    GetAsync,
    options
  );

  if (error) console.error(error);

  return { data, error, isLoading, mutate };
};
